// extracted by mini-css-extract-plugin
module.exports = {"searchSponsoredProductsContainer":"aO","product":"bO","products":"cO","tooltipWrapper":"dO","tooltip":"eO","title":"fO"};